import { render, staticRenderFns } from "./bot_status.vue?vue&type=template&id=d031a766&"
import script from "./bot_status.vue?vue&type=script&lang=js&"
export * from "./bot_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports